import React, { useState } from 'react';
import NavigationBar from '../../components/ui/NavigationBar';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

import MetricCard from '../student-dashboard/components/MetricCard';
import RecommendationAccuracyChart from './components/RecommendationAccuracyChart';
import QuizPerformanceChart from './components/QuizPerformanceChart';
import EngagementMetricsChart from './components/EngagementMetricsChart';
import FilterPanel from './components/FilterPanel';

const AnalyticsDashboard = () => {
  const [dateRange, setDateRange] = useState('30days');
  const [userType, setUserType] = useState('all');
  const [region, setRegion] = useState('all');

  const mockKPIMetrics = [
    {
      icon: 'Users',
      title: 'Utilisateurs Actifs',
      value: '2,847',
      subtitle: 'Total ce mois',
      color: 'blue',
      trend: 12
    },
    {
      icon: 'Target',
      title: 'Précision Recommandations',
      value: '87.5%',
      subtitle: 'Taux de satisfaction',
      color: 'green',
      trend: 5
    },
    {
      icon: 'TrendingUp',
      title: 'Taux de Complétion Quiz',
      value: '76.3%',
      subtitle: 'Moyenne globale',
      color: 'amber',
      trend: 8
    },
    {
      icon: 'Activity',
      title: 'Score d\'Engagement',
      value: '8.2/10',
      subtitle: 'Moyenne plateforme',
      color: 'purple',
      trend: 15
    }
  ];

  const handleExportData = (format) => {
    console.log(`Exporting data in ${format} format`);
    // Implementation for data export
  };

  const handleFilterChange = (filterType, value) => {
    switch (filterType) {
      case 'dateRange':
        setDateRange(value);
        break;
      case 'userType':
        setUserType(value);
        break;
      case 'region':
        setRegion(value);
        break;
      default:
        break;
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <NavigationBar />
      <main className="pt-20 pb-8 px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          {/* Header Section */}
          <div className="mb-6 md:mb-8">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-6">
              <div>
                <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-2">
                  Tableau de Bord Analytique
                </h1>
                <p className="text-sm md:text-base text-muted-foreground">
                  Insights complets sur les performances et l'engagement de la plateforme
                </p>
              </div>
              <div className="flex flex-wrap gap-3">
                <Button
                  variant="outline"
                  iconName="Download"
                  onClick={() => handleExportData('csv')}
                >
                  Exporter CSV
                </Button>
                <Button
                  iconName="FileText"
                  onClick={() => handleExportData('pdf')}
                >
                  Générer Rapport
                </Button>
              </div>
            </div>
          </div>

          {/* Filter Panel */}
          <FilterPanel
            dateRange={dateRange}
            userType={userType}
            region={region}
            onFilterChange={handleFilterChange}
          />

          {/* KPI Metrics */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
            {mockKPIMetrics?.map((metric, index) => (
              <MetricCard key={index} {...metric} />
            ))}
          </div>

          {/* Recommendation Accuracy Trends */}
          <div className="mb-6 md:mb-8">
            <RecommendationAccuracyChart dateRange={dateRange} />
          </div>

          {/* Quiz Performance Improvement */}
          <div className="mb-6 md:mb-8">
            <QuizPerformanceChart dateRange={dateRange} />
          </div>

          {/* Engagement Metrics */}
          <div className="mb-6 md:mb-8">
            <EngagementMetricsChart dateRange={dateRange} userType={userType} />
          </div>

          {/* Automated Insights */}
          <div className="bg-card rounded-xl p-4 md:p-6 border border-border shadow-sm">
            <div className="flex items-center gap-3 mb-4">
              <Icon name="Sparkles" size={24} className="text-primary" />
              <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">
                Insights Automatiques
              </h2>
            </div>
            <div className="space-y-3">
              <div className="flex items-start gap-3 p-3 rounded-lg bg-success/10">
                <Icon name="TrendingUp" size={20} className="text-success mt-0.5" />
                <div>
                  <p className="text-sm md:text-base font-medium text-foreground">
                    Amélioration significative de la précision des recommandations
                  </p>
                  <p className="text-xs md:text-sm text-muted-foreground mt-1">
                    +5.2% ce mois par rapport au mois précédent, particulièrement dans les filières scientifiques
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-3 rounded-lg bg-amber-50">
                <Icon name="AlertCircle" size={20} className="text-warning mt-0.5" />
                <div>
                  <p className="text-sm md:text-base font-medium text-foreground">
                    Baisse d'engagement le week-end
                  </p>
                  <p className="text-xs md:text-sm text-muted-foreground mt-1">
                    Les sessions utilisateur diminuent de 35% les samedis et dimanches
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3 p-3 rounded-lg bg-blue-50">
                <Icon name="Users" size={20} className="text-primary mt-0.5" />
                <div>
                  <p className="text-sm md:text-base font-medium text-foreground">
                    Forte croissance des utilisateurs à Dakar
                  </p>
                  <p className="text-xs md:text-sm text-muted-foreground mt-1">
                    +28% de nouveaux utilisateurs dans la région de Dakar ce trimestre
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default AnalyticsDashboard;